var toSentenceCase = function (str) {
    return str
        .toLowerCase()
        .replace(/\.\s*([a-z])|^[a-z]/gm, function (s) { return s.toUpperCase(); });
};
export default toSentenceCase;
//# sourceMappingURL=toSentenceCase.js.map